var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalHeading',_vm._b({attrs:{"title-in-capitals":false,"level":4},on:{"clickCloseIcon":function($event){return _vm.$emit('clickCloseIcon')}}},'ModalHeading',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }